module.exports = __webpack_public_path__ + "img/file-import.19819831.svg";